const root = 'MainMenu'

const menuItem = name => `${root}-menuItem-${name}`

export const TestId = {
  dashboard: menuItem('dashboard'),
  findProducts: menuItem('findProducts'),
  myProducts: menuItem('myProducts'),
  importList: menuItem('importList'),
  importListItemsCountChip: `${menuItem('importList')}-itemsCountChip`,
  syncList: menuItem('syncList'),
  syncListItemsCountChip: `${menuItem('syncList')}-itemsCountChip`,
  archiveList: menuItem('archiveList'),
  archiveListItemsCountChip: `${menuItem('archiveList')}-itemsCountChip`,
  pricingRules: menuItem('pricingRules'),
  orders: menuItem('orders'),
  inbox: menuItem('inbox'),
  settings: menuItem('settings'),
  connectStore: menuItem('connectStore'),
  connectToSupplier: menuItem('connectToSupplier'),
  managePlan: menuItem('managePlan'),
  storeProfile: menuItem('storeProfile'),
  businessInfo: menuItem('businessInfo'),
  userSettings: menuItem('userSettings'),
  logout: menuItem('logout'),
  helpCenter: menuItem('helpCenter'),
}
